import { Component, Input } from '@angular/core';
import { EventosGeneralesI } from 'src/app/interfaces/eventos.interface';

@Component({
  selector: 'app-item-agenda',
  templateUrl: './item-agenda.component.html',
  styleUrls: ['./item-agenda.component.css'],
})
export class ItemAgendaComponent {
  hide = false;

  @Input() item!: EventosGeneralesI[];

  obtenerFechasLunesADomingo(): { lunes: Date; domingo: Date } {
    const fechaActual = new Date();
    const diaActual = fechaActual.getDay(); // 0 (Domingo) a 6 (Sábado)
    let offsetLunes = 0;
    if (diaActual === 0) {
      offsetLunes = -6; // Si es domingo, retrocede 6 días al lunes de esta semana
    } else {
      offsetLunes = 1 - diaActual; // Retrocede al lunes de esta semana
    }

    const lunes = new Date();
    lunes.setDate(fechaActual.getDate() + offsetLunes);

    const domingo = new Date(lunes);
    while (domingo.getDay() !== 0) {
      domingo.setDate(domingo.getDate() + 1);
    }

    return { lunes, domingo };
  }

  addDays(date: Date, plus: number) {
    return date.setDate(date.getDate() + plus);
  }
}
